export const tryParseJSONObject = (jsonString) => {
    try {
      let o = JSON.parse(jsonString);
      if (o && typeof o === "object") {
        return o;
      }
    } catch (e) {}
    return false;
  };
